import React from "react";
import { Button, Grid } from "semantic-ui-react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { socket } from "../../../../lib/socketio";
import Footer from "../../Footer";
import { GroupTemplate } from "../../../Definitions/cl";
import PCSGroupColumn from "../../../Monitor/PCSGroupColumn";
import {
  Breaker,
  CircuitInside,
  Coil2,
  Line,
  ParallelLines,
  Breaker2,
} from "../../../Definitions/GraphicComponents";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { GRAPHICS_WRITE, isAuthorized } from "../../../../lib/authorization";

const PCSOvr_S300_PSM2 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  let history = useHistory();
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 269 }, { display_id: 128 }]);
      socket.on("receive tag names", (data) => {
        const isFound = data.tags_data.some(
          (element) => element.display_id === 269,
        );
        if (isFound) {
          settags(data.tags_data);
        }
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'FooterPSM2' ? [t] : []);
    t.display_id === 128 ? [t] : [],
  );

  const x = tags.flatMap((t) => (t.display_id === 269 ? [t] : []));
  const GenTags = x.filter((el) => el.tag_display_subgroup !== "Graphics");

  const display = GenTags.map((t) => t.page_name);
  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const pcstags = [];
  let rows;
  const length = GroupTags[0].length; // 7
  rows = Math.round(length / 4); // 2 : subGroup 수에 따라 입력

  let i = 0;
  if (length > 0) {
    while (i < length) {
      pcstags.push(GroupTags[0].slice(i, i + rows));
      i += rows;
    }
  }

  const grid = (tag_id, display_name) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column
          style={{
            color: data[tag_id] === 1 ? "red" : "white",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          {typeof data !== "undefined" && data !== null
            ? data[tag_id] === 1
              ? "CLOSED"
              : "OPEN"
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "#fff",
            fontSize: "15px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {display_name}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const grid_value = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        {" "}
        {/* value & unit */}
        <Grid.Column style={styles.value} name="value">
          {typeof data !== "undefined" &&
          data[tag_id] !== null &&
          typeof data[tag_id] !== "undefined"
            ? data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column style={styles.unit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        {" "}
        {/* tag name */}
        <Grid.Column
          style={{
            color: "#fff",
            fontSize: "18px",
            fontWeight: "bold",
            marginLeft: "5px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <div style={styles.innerdiv}>
        <div style={{ float: "right" }}>
          <div style={styles.menu}>
            <Button
              color="blue"
              content="PCS Faults (PSM2)"
              onClick={(event, value) => history.push("/PCSFaults_PSM2")}
            />
          </div>
        </div>
        <div style={{ textAlign: "center", marginLeft: "13%" }}>
          <h2 style={styles.header}>{display[0]}</h2>
        </div>

        <>
          <div style={styles.div}>
            <svg width="1750" height="500">
              <ParallelLines
                  lineA={{x1: 200, y1: 150, x2: 250, y2: 150}}
                  lineB={{x1: 215, y1: 160, x2: 235, y2: 160}}
              />
              <ParallelLines
                  lineA={{x1: 200, y1: 220, x2: 250, y2: 220}}
                  lineB={{x1: 215, y1: 230, x2: 235, y2: 230}}
              />
              <ParallelLines
                  lineA={{x1: 200, y1: 290, x2: 250, y2: 290}}
                  lineB={{x1: 215, y1: 300, x2: 235, y2: 300}}
              />
              <ParallelLines
                  lineA={{x1: 200, y1: 360, x2: 250, y2: 360}}
                  lineB={{x1: 215, y1: 370, x2: 235, y2: 370}}
              />
              <ParallelLines
                  lineA={{x1: 370, y1: 150, x2: 420, y2: 150}}
                  lineB={{x1: 385, y1: 160, x2: 405, y2: 160}}
              />
              <ParallelLines
                  lineA={{x1: 370, y1: 220, x2: 420, y2: 220}}
                  lineB={{x1: 385, y1: 230, x2: 405, y2: 230}}
              />
              <ParallelLines
                  lineA={{x1: 370, y1: 290, x2: 420, y2: 290}}
                  lineB={{x1: 385, y1: 300, x2: 405, y2: 300}}
              />
              <ParallelLines
                  lineA={{x1: 370, y1: 360, x2: 420, y2: 360}}
                  lineB={{x1: 385, y1: 370, x2: 405, y2: 370}}
              />
              <ParallelLines
                  lineA={{x1: 540, y1: 150, x2: 590, y2: 150}}
                  lineB={{x1: 555, y1: 160, x2: 575, y2: 160}}
              />
              <ParallelLines
                  lineA={{x1: 540, y1: 220, x2: 590, y2: 220}}
                  lineB={{x1: 555, y1: 230, x2: 575, y2: 230}}
              />
              <ParallelLines
                  lineA={{x1: 540, y1: 290, x2: 590, y2: 290}}
                  lineB={{x1: 555, y1: 300, x2: 575, y2: 300}}
              />
              <ParallelLines
                  lineA={{x1: 540, y1: 360, x2: 590, y2: 360}}
                  lineB={{x1: 555, y1: 370, x2: 575, y2: 370}}
              />
              <Line
                  corner1={{x: 225, y: 160}}
                  corner2={{x: 225, y: 220}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 225, y: 230}}
                  corner2={{x: 225, y: 290}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 225, y: 300}}
                  corner2={{x: 225, y: 360}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 395, y: 160}}
                  corner2={{x: 395, y: 220}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 395, y: 230}}
                  corner2={{x: 395, y: 290}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 395, y: 300}}
                  corner2={{x: 395, y: 360}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 565, y: 160}}
                  corner2={{x: 565, y: 220}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 565, y: 230}}
                  corner2={{x: 565, y: 290}}
                  thickness={3}
                  color="white"
              />
              <Line
                  corner1={{x: 565, y: 300}}
                  corner2={{x: 565, y: 360}}
                  thickness={3}
                  color="white"
              />
              <path
                  d="M 225, 150 L 225, 75 L 650,75 "
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/* TOP */}
              <Breaker2 rect={{cx: 655, cy: 75, type: "inv"}}/>
              <path
                  d="M 690, 75 L 800, 75 L 800, 250"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/*Corner */}
              <path
                  d="M 225, 370 L 225, 440 L 800, 440 L 800, 260"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/* Bottom */}
              <path
                  d="M 395, 75 L 395, 150"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <path
                  d="M 565, 75 L 565, 150"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <path
                  d="M 395, 370 L 395, 440"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <path
                  d="M 565, 370 L 565, 440"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <ParallelLines
                  lineA={{x1: 790, y1: 250, x2: 810, y2: 250}}
                  lineB={{x1: 790, y1: 260, x2: 810, y2: 260}}
              />
              <path
                  d="M 800, 220 L 750, 220 L 750 240 L 740, 245 L 760, 250 L 735, 255 L 760, 260 L 740, 265 L 750, 270 L 750, 290 L 800, 290 "
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/* mW */}
              <path
                  d="M 800, 75 L 900, 75 L 900, 220"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <path
                  d="M 800, 440 L 900, 440 L 900 290"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              <rect
                  x={850}
                  y={220}
                  width="100"
                  height="70"
                  stroke="white"
                  strokeWidth={3}
              />
              {" "}
              {/*bigger enclosed rect / TAG : CP_PCS100AVAILABILITY */}
              <CircuitInside
                  lineA={{x1: 875, y1: 240, x2: 875, y2: 270}}
                  lineB={{x1: 880, y1: 240, x2: 880, y2: 270}}
                  color="white"
              />
              <path
                  d="M 952, 255 L 992, 255 "
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/**Coil to ? */}
              <Coil2 rect={{cx: 1000, cy: 255}}/>
              <path
                  d="M 1040, 255 L 1080, 255 L 1080, 285"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/**Coil to ParallelLines */}
              <ParallelLines
                  lineA={{x1: 1070, y1: 285, x2: 1090, y2: 285}}
                  lineB={{x1: 1070, y1: 295, x2: 1090, y2: 295}}
              />
              <path
                  d="M 1080, 295 L 1080, 325"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/**Coil to ParallelLines */}
              <path
                  d="M 1080, 255 L 1230, 255"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/**Coil to ParallelLines */}
              <path
                  d="M 1270, 255 L 1380, 255"
                  stroke="white"
                  strokeWidth={3}
                  fill="none"
              />
              {" "}
              {/**Coil to ParallelLines  */}
              <Breaker rect={{cx: 1235, cy: 255, type: "inv"}}/>
              <text
                  x={1420}
                  y={255}
                  font-size={20}
                  fontWeight="bold"
                  dominant-baseline="middle"
                  text-anchor="middle"
                  fill="white"
              >
                GRID
              </text>
              <text x={1420} y={275} font-size={18} fontWeight='bold' dominant-baseline="middle" text-anchor="middle"
                    fill={data[39621] === 1 ? 'green' : 'red'}>
                {data[39621] === 1 ? 'OK' : 'OFF'}
              </text>
              <foreignObject x={230} y={150} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13468)} {/**VT01 */}
                </div>
              </foreignObject>
              <foreignObject x={230} y={220} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13469)} {/**VT02 */}
                </div>
              </foreignObject>
              <foreignObject x={230} y={290} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13470)} {/**VT03 */}
                </div>
              </foreignObject>
              <foreignObject x={230} y={360} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13471)} {/**VT04 */}
                </div>
              </foreignObject>
              <foreignObject x={400} y={150} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13472)} {/**VT05 */}
                </div>
              </foreignObject>
              <foreignObject x={400} y={220} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13473)} {/**VT06 */}
                </div>
              </foreignObject>
              <foreignObject x={400} y={290} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13474)} {/**VT07 */}
                </div>
              </foreignObject>
              <foreignObject x={400} y={360} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13475)} {/**VT08 */}
                </div>
              </foreignObject>
              <foreignObject x={570} y={150} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13476)} {/**VT09 */}
                </div>
              </foreignObject>
              <foreignObject x={570} y={220} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13477)} {/**VT10 */}
                </div>
              </foreignObject>
              <foreignObject x={570} y={290} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13478)} {/**VT11 */}
                </div>
              </foreignObject>
              <foreignObject x={570} y={360} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid_value(13479)} {/**VT12 */}
                </div>
              </foreignObject>
              {/* <foreignObject x={185} y = {30} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17366)}  
                                </div>
                            </foreignObject>

                            <foreignObject x={360} y = {30} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17374)}  
                                </div>
                            </foreignObject>

                            <foreignObject x={535} y = {30} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17382)}  
                                </div>
                            </foreignObject>

                            <foreignObject x={185} y = {445} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17390)}  
                                </div>
                            </foreignObject>

                            <foreignObject x={360} y = {445} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17398)}  
                                </div>
                            </foreignObject>

                            <foreignObject x={535} y = {445} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid_value(17406)}  
                                </div>
                            </foreignObject> */}
              <foreignObject x={647} y={83} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid(32009, "DCMC")}{" "}
                  {/** PSM2_DINPCS_COMPONENTSTS_DCMC_VALUE  */}
                </div>
              </foreignObject>
              <foreignObject x={1227} y={265} width={150} height={40}>
                <div style={{height: "100%"}}>
                  {grid(32008, "ACCB")}{" "}
                  {/** MC1 : PSM2_DINPCS_COMPONENTSTS_ACCB_VALUE */}
                </div>
              </foreignObject>
            </svg>
          </div>
        </>

        <Grid
            width="1800px"
            inverted
            divided
            centered
            columns="equal"
            style={styles.grid}
        >
          <Grid.Column style={{maxWidth: "1800px" }}>
            <Grid inverted divided centered columns="equal" style={styles.grid}>
              {pcstags.map((c, i) => (
                <PCSGroupColumn index={i} column={c} data={data} option={2} />
              ))}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  grid: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "10px",
    width: "100%",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  value: {
    marginLeft: "30px",
    maginRight: "0px",
  },
  unit: {
    color: "yellow",
    marginLeft: "20px",
  },
};

export default PCSOvr_S300_PSM2;
